<template>
    <v-container fluid>
        <h1 class="text-center bot-blue">Tạo file QRCode từ excel</h1>
        <bot-spinner v-model="spinner">
            <v-file-input
                v-model="values.files"
                placeholder="Upload files"
                label="Upload files"
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                @change="onFileChange"
                show-size
            ></v-file-input>
            <v-row>
                <v-col>
                    <v-col>Tên file:</v-col>
                    <v-col>
                        <v-combobox
                            v-model="values.fileName"
                            :items="items.fileNames"
                            label="chọn cột tên file"
                            dense
                            append-icon=""
                            persistent-hint
                        >
                        </v-combobox>
                    </v-col>
                </v-col>
                <v-col>
                    <v-col>Nội dung:</v-col>
                    <v-col>
                        <v-combobox
                            v-model="values.fileText"
                            :items="items.fileTexts"
                            label="chọn nội dung qrcode"
                            dense
                            append-icon=""
                            persistent-hint
                        >
                        </v-combobox>
                    </v-col>
                </v-col>
            </v-row>
            <div class="text-center">
                <v-btn
                    class="ma-2"
                    color="primary"
                    :disabled="!isValidAll"
                    @click="submit"
                >
                    Xác nhận
                    <v-icon right> mdi-check </v-icon>
                </v-btn>
            </div>
        </bot-spinner>
    </v-container>
</template>

<script>
const maxSize = 6 * 1024; // 6MB
const cafe = {
    default: {
        sp: {
            snb: "views/snackbar/show",
            authen: {
                loadConfig: "authen/loadConfig",
                qrcode: {
                    create: "authen/qrcode/create",
                },
            },
            excel: {
                read: "views/excel/read",
            },
        },
        maxSize,
    },
    sms: {
        maxSize: `File excel phải nhỏ hơn ${maxSize / 1024}MB!`,
        success: {
            write: "Ghi ảnh thành công!",
        },
    },
};
const df = cafe.default;

export default {
    name: "Home",

    components: {},

    // this is state
    data() {
        return {
            cpo: this.$options.filters.cpo,
            hdownload: this.$options.filters.hdownload,
            isValidAll: false,
            values: {
                files: null,
                fileName: null,
                fileText: null,
                data: [],
            },
            items: {
                fileNames: [],
                fileTexts: [],
            },
            snackbar: {
                text: "Hello snackbar!",
                color: "warning",
            },
            spinner: {
                visible: false,
                color: "red",
            },
        };
    },

    async asyncData({ store }) {
        const dp = store.dispatch;
        await dp(df.sp.authen.loadConfig);
    },

    computed: {
        cfqrcode() {
            const main = this;
            let cf = main.$store.state.authen.config;
            let data = main.cpo(cf.ConfigToolQRCode || {});
            return data;
        },
    },

    methods: {
        async onFileChange() {
            const main = this;
            const dp = main.$store.dispatch;
            const file = main.values.files;
            main.spinner.visible = true;
            let payload = {
                key: "qrcode-excel",
                file,
            };
            const res_read = await dp(df.sp.excel.read, payload);
            const { props, data } = res_read;
            let isData = Array.isArray(data);
            let isProps = Array.isArray(props);
            if (!isData || !isProps) return;
            const { fileName, fileText } = main.cfqrcode.props;
            main.items.fileNames = main.cpo(props);
            main.items.fileTexts = main.cpo(props);
            main.values = Object.assign(main.values, {
                data,
                fileName,
                fileText,
            });
            main.isValidAll = true;
            main.spinner.visible = false;
        },
        async submit() {
            const main = this;
            const file = main.values.files;
            if (!file) return; // single file
            const dp = main.$store.dispatch;
            let text = cafe.sms.maxSize;
            const isLtMax = file.size / 1024 < df.maxSize;
            if (!isLtMax) return dp(df.sp.snb, { text, color: "error" });
            const { fileName, fileText } = main.values;
            let payload = main.cpo(main.cfqrcode);
            payload.data = [];
            payload.props = { fileName, fileText };
            for (let item of main.values.data) {
                let child = {
                    [fileName]: item[fileName],
                    [fileText]: item[fileText],
                };
                if (typeof child[fileText] === "object")
                    child[fileText] = child[fileText].text;
                payload.data.push(child);
            }
            main.spinner.visible = true;
            const res_create = await dp(df.sp.authen.qrcode.create, payload);
            text = res_create.error;
            if (text) return dp(df.sp.snb, { text, color: "error" });
            text = cafe.sms.success.write;
            dp(df.sp.snb, { text, color: "success" });
            let filePath = res_create.data.fileName;
            let href = filePath.substring(1, filePath.length);
            main.hdownload.file(href);
            main.spinner.visible = false;
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped></style>



// WEBPACK FOOTER //
// qrcode.create.vue